export const environment = {
  tenant: 'por-us',
  apiUrl: 'https://api-por-us-b.dev.tillster.com',
  pgaasUrl: 'https://api-pgaas-us-east-1.stage.eagle.tillster.com/v2',
};
